import React from 'react';
import { useMaintenance } from '../../context/MaintenanceContext';
import MaintenancePage from '../../views/pages/maintenance';
import LoadingPage from './LoadingPage';

/**
 * MaintenanceGuard component
 * Blocks children and shows MaintenancePage if maintenance mode is enabled.
 * Shows a loading state while fetching the initial config.
 */
const MaintenanceGuard = ({ children }) => {
    const { isMaintenanceMode, loading } = useMaintenance();

    if (loading) {
        return <LoadingPage />;
    }

    if (isMaintenanceMode) {
        return <MaintenancePage />;
    }

    return children;
};

export default MaintenanceGuard;
